/**
 * Requirements summary:
 * - Every email format check in the app shares this one rule.
 * - It accepts exactly what `/^[^\s@]+@[^\s@]+\.[^\s@]+$/` accepts: one `@`,
 *   no whitespace, a non-empty part before the `@`, and a dot after it that is
 *   neither the first nor the last character of the domain.
 * - It is written without that regex because the regex backtracks
 *   quadratically on a failing domain full of dots (`a@....@`), and several
 *   callers are public routes that check text anyone can send. Every step here
 *   is one pass over the text.
 */

export function isValidEmailAddress(email: string): boolean {
  // RegExp.test turned its argument into a string, so a null or undefined
  // reached it as "null" / "undefined" and was refused rather than throwing.
  // (A Symbol made the regex throw; here it is refused.)
  const value = String(email);
  const at = value.indexOf('@');
  if (at < 1 || at !== value.lastIndexOf('@')) return false;
  if (/\s/.test(value)) return false;
  return value.slice(at + 1).slice(1, -1).includes('.');
}
